import type { CurrencyAmount } from '@/api';
import cc from 'currency-codes';

type CurrencyCode = NonNullable<CurrencyAmount['iso_4217_alpha_3']>;

/**
 * Grabs the “codes” array provided by currency-codes
 * and tells TypeScript it matches our union.
 */
export function getValidCurrencyCodes(): CurrencyCode[] {
  return cc.codes() as CurrencyCode[];
}

/**
 * If you need { label, value } options:
 */
export function getCurrencyOptions(): {
  label: string;
  value: CurrencyCode;
  type: 'option';
}[] {
  return getValidCurrencyCodes().map(code => ({
    label: code,
    value: code,
    type: 'option',
  }));
}
